import { render, staticRenderFns } from "./CohortList.vue?vue&type=template&id=19bd9f06&scoped=true&"
import script from "./CohortList.vue?vue&type=script&lang=js&"
export * from "./CohortList.vue?vue&type=script&lang=js&"
import style0 from "./CohortList.vue?vue&type=style&index=0&id=19bd9f06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd9f06",
  null
  
)

export default component.exports